// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** web页面埋点 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /web-track/upload-event */
export async function webTrackUploadEventUsingPOST(
  body: API.WebTrackEventReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/web-track/upload-event", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
